import { createApp } from 'vue';
import PafToWavConverter from '@/Components/PafToWavConverter.vue';
import '@styles/app.css';

createApp(PafToWavConverter).mount('#paf-to-wav-converter');
